<template>
  <div style="height: 100%">
    <div class="trade-row" :class="{ mobile: $mq === 'mobile' }">
      <ic-tab
        v-if="$mq === 'mobile'"
        v-model="tab"
        :items="[
          { key: 'order-book', text: $t('trade.order-book') },
          { key: 'recent-trades', text: $t('trade.recent-trades') },
        ]"
      />
      <order-book
        v-if="$mq !== 'mobile' || tab === 'order-book'"
        :loading="ordersLoading"
        :orders="orders"
        :offers="offers"
        :brand="brand"
        @order="getActiveOrder"
      />
      <recent-trades
        v-if="$mq !== 'mobile' || tab === 'recent-trades'"
        :loading="tradesLoading"
        :trades="trades"
        :brand="brand"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Empty from '../components/Empty'
import RecentTrades from '../components/RecentTrades'
import OrderBook from '../components/OrderBook'
import OrderBookMixin from '../mixins/OrderBookMixin'

/**
 * Авах зарах захиалгын сан болон
 * Биелсэн захиалгын санг агуулсан View
 */
export default {
  components: {
    Empty,
    RecentTrades,
    OrderBook,
  },
  mixins: [ OrderBookMixin ],
  props: {
    symbol: {
      type: String,
      required: false,
    },
    brand: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tab: 'order-book',
      isLoading: false,
      currentInterestedSymbol: '',
      orderSubscription: null,
    }
  },
  computed: {
    ...mapState('cent', ['token', 'instance', 'connected', 'currentOrderSub']),
    ...mapState('trade', [
      'orders',
      'trades',
      'offers',
      'ordersLoading',
      'tradesLoading'
    ]),
  },
  watch: {
    symbol: {
      handler: 'fetchData',
    },
    orders: {
      handler: 'setBrandPrice',
    },
    offers: {
      handler: 'setBrandPrice',
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    ...mapActions('brand', ['setBrand']),
    setBrandPrice() {
      // TODO: refactor needed.
      this.brand.high_price =
        this.offers.length > 0
          ? this.offers[this.offers.length - 1].price
          : this.brand.closing_price
      this.brand.low_price =
        this.orders.length > 0 ? this.orders[0].price : this.brand.closing_price

      this.setBrand(this.brand)
    },
    async fetchData() {
      if (typeof this.symbol === 'undefined' || !this.symbol || this.symbol === 'undefined') return
      try {

        // Ер нь логик бүхий кодуудыг cent.js буюу store-луу орууллаа.
        // Одоо үүнээс цааш цэгцтэй явна.
        this.$store.dispatch('trade/fetchTrades', this.symbol)
        this.$store.dispatch('trade/fetchOrderBook', this.symbol)

        await this.$store.dispatch('cent/unsubscribeCurrent')
        await this.$store.dispatch('cent/subscribeChannels', this.symbol)

        this.scrollToBottom()
      } catch (e) {
        console.error(e)
      }
    },

    getActiveOrder(value) {
      this.$emit('order', value)
    },
  },
}
</script>
